import { css } from "@emotion/css";

import { blue, white } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createDetailLayoutStyles = ({ spacing, palette }: Theme) => {
  return {
    root: css({
      display: "flex",
      flexDirection: "column",
      backgroundColor: white,
      transition: "background-color 0.2s",
    }),
    header: css({
      padding: spacing([0, 3]),
    }),
    container: css({
      display: "flex",
      height: "100%",
    }),
    navButton: css({
      appearance: "none",
      background: "transparent",
      border: "none",
      cursor: "pointer",
      padding: 0,
    }),
    arrowBack: css({
      display: "flex",
      justifyContent: "flex-start",
      alignItems: "center",
      height: 30,
      marginTop: spacing(3),
    }),
    details: css({
      display: "flex",
      alignItems: "center",
      margin: spacing([1.5, 0]),
      minHeight: 30,
    }),
    task: css({
      backgroundColor: palette.secondary.light,
    }),
    taskDone: css({
      backgroundColor: palette.primary.light,
    }),
    tutorial: css({
      backgroundColor: blue[200],
    }),
  };
};
